export default "__VITE_ASSET__n62_eppi__"